export default __webpack_public_path__ + "static/media/04.6bc1ea52.svg";